/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Select_Team_Members_LabelInputs */



/**
* | output |
* | --- |
* | "Select team members" |
*
* @param {Team_Share_Select_Team_Members_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_select_team_members_label = /** @type {((inputs?: Team_Share_Select_Team_Members_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Select_Team_Members_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionner les membres de l’équipe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Teammitglieder auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona i membri del team")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите членов команды")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar miembros del equipo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择团队成员")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チームメンバーを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टीम के सदस्यों का चयन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione os membros da equipe")
	return /** @type {LocalizedString} */ ("Select team members")
});